<template>
    <div class="footerWrap">
        <ul>
            <router-link to="/" tag="li" exact>
                <img src="../assets/shop.png" alt="">
                <span>会员专区</span>
            </router-link>
            <router-link to="/myCard" tag="li" exact>
                <img src="../assets/code.png" alt="">
                <span>我的卡券</span>
            </router-link>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'footerCom',
    data() {
        return {

        }
    },
    methods: {
    }
}
</script>
<style lang="sass" scoped>
.router-link-active
    background: #A4B3C1;
.footerWrap
    width: 100%;
    heigth: 0.6rem;
    background: #6A7D8F;
    ul
        width: 100%;
        heigth: 0.6rem;
        display: flex;
        li
            flex: 1;
            img
                width: 0.4rem;
                heigth: auto;
                display: block;
                margin: 0 auto;
            span
                display: block;
                text-align: center;
                color: #fff;
                line-height: 0.2rem;
</style>


// WEBPACK FOOTER //
// src/components/footer.vue